import type { App } from 'vue';
import ClientOnly from '@duannx/vue-client-only';

export default {
  install(app: App) {
    app.component('ClientOnly', ClientOnly);
  },
};
